import { AnnouncementStatus } from '@/api/announcements/types';
import { FilledButton } from '@/components/UI/Button';
import { Box, styled, Typography } from '@mui/material';

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '24px',
}));

export const PageTitle = styled(Typography)(() => ({
  color: '#1A1A1A',
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '140%',
  textTransform: 'uppercase',
}));

export const PageSubtitle = styled(Typography)(() => ({
  color: '#475467',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '140%',
}));

export const NewAnnouncementButton = styled(FilledButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  width: 'fit-content',
  padding: '10px 24px',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const TableWrapper = styled(Box)(() => ({
  '& .table-row-body': {
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.8,
      transition: '0.3s',
      backgroundColor: '#47546710',
    },
  },
}));

export const InfoBanner = styled(Box)(({ theme }) => ({
  backgroundColor: '#E9FBF8',
  border: `1px solid ${theme.palette.secondary.main}40`,
  borderRadius: '8px',
  padding: '12px 24px',
  margin: '24px 0',
  color: '#1A1A1A',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '140%',
}));

const statusChipColors: Record<
  AnnouncementStatus,
  { background: string; color: string }
> = {
  active: { background: '#D6F4EE', color: '#00806F' },
  draft: { background: '#FFF4CC', color: '#B58A00' },
  inactive: { background: '#EAECF0', color: '#475467' },
};

export const StatusChip = styled('span')<{ status: AnnouncementStatus }>(
  ({ status }) => ({
    backgroundColor: statusChipColors[status].background,
    color: statusChipColors[status].color,
    borderRadius: '16px',
    padding: '4px 12px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '140%',
    whiteSpace: 'nowrap',
  })
);
